import HeaderNav from "./HeaderNav";

const Header = () => {
    return (
        <HeaderNav />
    );
};

export default Header;